import React, {useEffect, useState} from "react"

import { Row, Col, Card, CardBody, CardTitle, Button, Container, Form, Label, Input } from "reactstrap"
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css"
import { CSVLink } from "react-csv";
import "./datatables.scss"
import { MDBDataTable } from "mdbreact"
// React Select
import Select from "react-select"
//Import Breadcrumb
// import Breadcrumbs from "../../components/Common/Breadcrumb"
import Modal from 'react-modal';
import URLSearchParams from '@ungap/url-search-params'
// MomentJS
import moment from 'moment'
import SweetAlert from "react-bootstrap-sweetalert"

const PromotionCodes = (props) => {
  const [modalIsOpen,setIsOpen] = useState(false);
  const [length,setLength] = useState('');
  const [codeType, setCodeType] = useState('single');
  const [cat_ID, setCatID] = useState(0)
  const [promoCodes, setPromoCodes] = useState([])
  const [success_msg, setsuccess_msg] = useState(false)
  const [errorMessage, setErrorMessage] = useState('')
  const [successMsgText, setSuccessMsgText] = useState('')
  const [errorMsgAlert, setErrorMsgAlert] = useState(false)
  const [campaignName, setCampaignName] = useState('')
  const [csvData, setCsvData] = useState([])
  let csvRows = []

  useEffect(() => {
    let token = localStorage.getItem("AuthenticationToken")
    let categoryID = props.location ? props.location.state.cat_ID : "";
    setCatID(categoryID)
    if(token){
      getPromoCodes(categoryID, token)
    }
    return () => {
    }
  }, [])

  const getPromoCodes = async (campaignID, token) => {
    let _headers  = {
      "Content-Type":  "application/x-www-form-urlencoded",
      "Authorization": "Bearer " + token
    }
    var requestOptions = {
      method: 'GET',
      headers: _headers,
      redirect: 'follow'
    };
    let url = `${process.env.REACT_APP_TOKRI_API_URL}/api/campaigns/` + campaignID;    
    await fetch(url , requestOptions)
      .then(response => response.text())
      .then(result => {
        let result1 = JSON.parse(result) 
        if(result1[0]?.name !== ''){
          setCampaignName(result1[0].name)
        }
        result1[0]?.promocodes?.length > 0 && result1[0].promocodes.map((item)=> {
              let tempRow = {
                code: item.code,
                type: item.code_type,
                createdDate: moment(item.created_at).format('MMMM Do, YYYY'),
                status: item?.status?.status
              }
              promoData.rows = [...promoData.rows, tempRow]
              csvRows.push(tempRow)
          })
          setPromoCodes(promoData)
          setCsvData(csvRows)
      })
      .catch(error => console.log('error', error));
  }
  const submitPromoCode = async (e) => {
    e.preventDefault();
    const token = localStorage.getItem("AuthenticationToken")
    var promoInput = document.getElementById("promocode-input").value
    let _headers  = {
      "Content-Type":  "application/x-www-form-urlencoded",
      "Authorization": "Bearer " + token
    }
    var urlencoded = new URLSearchParams();
    if(codeType.value == 'single'){
      var noOfCodes = document.getElementById("no-of-codes-input").value ? document.getElementById("no-of-codes-input").value : ""
      if(promoInput == '')
      {
        setErrorMessage("Prefix is required")
        setErrorMsgAlert(true)
        return
      }
      if(length == ''){
        setErrorMessage("Length is required")
        setErrorMsgAlert(true)
        return
      }
      if(noOfCodes == ""){
        setErrorMessage("No of Codes is required")
        setErrorMsgAlert(true)
        return
      }
    urlencoded.append("campaign_id", cat_ID);
    urlencoded.append("code_type", codeType.value);
    urlencoded.append("code", promoInput);
    urlencoded.append("length", length ? length.value : "" );
    urlencoded.append("number_of_code", noOfCodes ? noOfCodes : "" );
    }else if(codeType.value == 'multi'){
      if(promoInput == '')
      {
        setErrorMessage("Name is required")
        setErrorMsgAlert(true)
        return
      }
    urlencoded.append("campaign_id", cat_ID);
    urlencoded.append("code_type", codeType.value);
    urlencoded.append("code", promoInput);
    }

    var requestOptions = {
      method: 'POST',
      headers: _headers,
      body: urlencoded,
      redirect: 'follow'
    };
    await fetch(`${process.env.REACT_APP_TOKRI_API_URL}/api/campaigns/promotioncodes`, requestOptions)
      .then(response => response.json())
      .then(result => {
        if(result.message){
          setIsOpen(false)        
          getPromoCodes(cat_ID, token)
          setsuccess_msg(true)
          setSuccessMsgText(result?.message)
        }else{
          setErrorMessage(result?.message)
          setErrorMsgAlert(true)
        }
    })
      .catch(error => console.log('error', error));
  }
  const renderSuccessAlert = () => {
    return (
      <SweetAlert
        title="Success!"
        success
        confirmBtnBsStyle="success" 
        onConfirm={() => {
          setsuccess_msg(false)          
        }}
      >
        {successMsgText ? successMsgText : "Promotion Code(s) Created Successfully."}
      </SweetAlert>
    )
  }
  const renderFailureAlert = () => {
    return (
      <SweetAlert
        title="Error!"
        warning
        confirmBtnBsStyle="warning"
        onConfirm={() => {
          setErrorMsgAlert(false)
        }}
      >
        {errorMessage ? errorMessage : "Error. Something went wrong."}
      </SweetAlert>
    )
  }
//   const handlePromoCodeChange = (text) => {
//       setPromoCodeValue(text.target.value)
//   }
//   const handleNoofCodes = (text) => {
//     setNoofCodes(text.target.value)
// }
  const typeOptions = [
    {
      options: [
        { label: "Single Use", value: "single" },
        { label: "Multi Use", value: "multi" }
      ]
    }
  ]
  const numOfCodes = [
    {
      options: [
        { label: "6", value: "6" },
        { label: "7", value: "7" },
        { label: "8", value: "8" },
        { label: "9",value: "9" },
        { label: "10", value: "10" },
        { label: "11", value: "11" },
        { label: "12", value: "12" },
        { label: "13", value: "13" },
        { label: "14", value: "14" },
        { label: "15", value: "15" },
        { label: "16", value: "16" },
        { label: "17", value: "17" },
        { label: "18", value: "18" },
        { label: "19", value: "19" },
        { label: "20", value: "20" },
        { label: "21", value: "21" },
        { label: "22", value: "22" },
        { label: "23", value: "23" },
        { label: "24", value: "24" }
      ]
    }
  ]
  const headers = [
    { label: "Code", key: "code" },
    { label: "Type", key: "type" },
    { label: "Created Date", key: "createdDate" },
  ];
  const promoData = {
    columns: [
      {
        label: "Code",
        field: "code",
        sort: "asc",
        width: 150,
      },
      {
        label: "Type",
        field: "type",
        sort: "asc",
        width: 270,
      },
      {
        label: "Date Created",
        field: "createdDate",
        sort: "asc",
        width: 270,
      },
      {
        label: "Status",
        field: "status",
        sort: "asc",
        width: 270,
      }
    ],
    rows: []
  }
  function toggleModal() {
    setIsOpen(!modalIsOpen);
  }

  function createCodeModal() {
    return (
      <Modal
          isOpen={modalIsOpen}
          // onAfterOpen={afterOpenModal}
          onRequestClose={toggleModal}
          ariaHideApp={false}
          style={{
            overlay: {
              position: "fixed",
              backgroundColor: "rgba(102, 102, 102, 0.75)",
              zIndex: 10
            },
            content: {
              border: "0",
              borderRadius: "4px",
              bottom: "auto",
              minHeight: "10rem",
              left: "50%",
              padding: 0,
              position: "fixed",
              right: "auto",
              top: "50%",
              transform: "translate(-50%,-50%)",
              minWidth: "20rem",
              width: "80%",
              maxWidth: "60rem",
            },
          }}
          contentLabel="Example Modal"
          >
            <Container fluid={true}
            > 
            <Row>
            <Col>
            <Card>
            <CardBody>
            <Row>
                <Col lg={3} style={{textAlign: "left"}}>
                    <CardTitle className="h4">Create Promo Code</CardTitle>      
                </Col>
                <Col lg={9}></Col>
            </Row>
            <Row>
            <Col>
            <div className="mt-5 mt-lg-4">
                  <Form 
                   className=""
                   method="post"
                   id="tooltipForm">
                    <div>              
                      <Row>
                          <div className="mb-4 position-relative">
                            <Label>Type</Label>
                            <Select
                              isMulti={false}                                
                              classNamePrefix="select2-selection"
                              class="form-select"
                              placeholder={codeType ? codeType.label : "Select Type"}
                              value={codeType? codeType.value : ""}
                              defaultValue={codeType? codeType.value : ""}
                              isSearchable={false}
                              options={typeOptions}
                              onChange={(e)=>{
                                  if(e){
                                    setCodeType(e)
                                  }
                              }}
                              required
                              />
                          </div>
                      </Row>
                      <Row>
                        <Col>
                          <div className="mb-4 position-relative">
                            <Label className="col-sm-10 col-form-label" htmlFor="formrow-firstname-input">{codeType && codeType.value == 'single' ?  "Prefix" : "Name"}</Label>
                            <Input type="text" className=".form-control-sm" id="promocode-input" 
                            placeholder={codeType && codeType.value == 'single' ?  "Enter Prefix" : "Enter Name"}
                            // onChange={(e)=>{
                            //   handlePromoCodeChange(e)
                            // }}
                            required
                            />    
                           </div>
                        </Col>
                      </Row>  
                      {codeType.value == 'single' &&
                      <Row>
                        <Col>
                          <div className="mb-4 position-relative">
                            <Label className="col-sm-10 col-form-label" htmlFor="formrow-firstname-input">{"No. of Codes"}</Label>
                            <Input type="text" className=".form-control-sm" id="no-of-codes-input" 
                            placeholder={"Enter No. of Codes"}
                            // onChange={(e)=>{
                            //   handleNoofCodes(e)
                            // }}
                            required
                            />    
                           </div>
                        </Col>
                      </Row>}
                      {codeType.value == 'single' &&
                        <Row>
                          <div className="mb-6 col-sm-10">
                            <Label>Length</Label>
                            <Select
                              isMulti={false}                                
                              classNamePrefix="select2-selection"
                              class="form-select"
                              placeholder={length ? length.label : "Enter length"}
                              value={length? length.value : ""}
                              defaultValue={length? length.value : ""}
                              isSearchable={false}
                              options={numOfCodes}
                              onChange={(e)=>{
                                  if(e){
                                    setLength(e)
                                  }
                              }}
                              required
                              />
                          </div>
                      </Row>}
                          <div className="text-center mt-4">
                            <Button type="submit" color="primary" className="btn btn-primary waves-effect waves-light"
                            onClick={(e)=>{
                              submitPromoCode(e)
                            }}
                          >Submit</Button>
                          </div>
                      </div>
                      </Form>
                      </div>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </Modal>
    );
  }

  const csvReport = {
    data: csvData,
    headers: headers,
    filename: `${campaignName ? campaignName : "Frasers eStore"}_Promo_Codes.csv`
  };
  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          {/* <Breadcrumbs title="Tables" breadcrumbItem="Responsive Table" /> */}

          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>
                    <Row style={{justifyContent: "space-between"}}>
                        <Col lg={3} style={{textAlign: "left"}}>
                        <CardTitle className="h4">{`${campaignName ? campaignName + "'s" : "Frasers eStore"} Promotion Codes`}</CardTitle>      
                        </Col>
                        <Col lg={6}></Col>
                        <Col lg={2} style={{ textAlign: "right"}}>
                            {/* <Button outline color="secondary" size='md'
                            onClick={()=>{
                              setIsOpen(true)
                            }}
                            >Create Code</Button> */}
                            {createCodeModal()}
                        </Col>
                        <Col lg={1} style={{flexDirection: "row", justifyContent: "center",  }}>
                        <Container>
                        <CSVLink style={{flexDirection: "column",   flex: 1}} {...csvReport}>
                              <i className="uil-file-download-alt" style={{fontSize: 24, alignSelf: "right", color: "black"}}/>
                        </CSVLink>
                        </Container>
                        </Col>
                    </Row>
                  <div style={{marginBottom: 50}}></div>
                  {/* <p className="card-title-desc">
                    This is an experimental awesome solution for responsive
                    tables with complex data.
                  </p> */}
                  <div>
                  <MDBDataTable responsive bordered data={promoCodes} />
                  </div>
                      { success_msg ? (
                            renderSuccessAlert()
                          )
                          :
                          null
                      }
                      { errorMsgAlert ? (
                        renderFailureAlert()
                      )
                      :
                      null
                      }
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    </React.Fragment>
  )
}

export default PromotionCodes;
